module.exports = __webpack_public_path__ + "static/media/warning-red.0ecd4ed2.svg";